import React, {useState} from 'react';
import Form from "../../../../gd-form/form/form-ui5/form";
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import TextareaRTE from "../../../../gd-form/form-element/textarea-rte/textarea-rte";
import MentionsManager from "../../../../gd/manager/mentions/mentions-manager"
import ButtonSubmitAI from "../../../../../app/ai-chat/components/chat/button/btn-submit-ai";
import AiAgentSelector from "../../../../../app/ai-chat/components/chat/selectors/agent-selector";
import AiChatModule from "../../ai-chat";
import FormManager from "../../../../gd-form/common/form-manager";
import {useForceUpdate} from "../../../../gd/utils/dom-and-react/react-utils";

type Props = {
    className?              : string
    module                  : AiChatModule
    sendMessageArea         : React.RefObject<any>
    textArea                : React.RefObject<any>
    scrollRef               : React.RefObject<any>
    form                    : FormManager
}

// const debug = "WriteWithAi_InputMessage"
const debug = false

// m-l-25 m-r-25
export default function WriteWithAi_InputMessage(props: Props) {

    const [message, setMessage] = useState<string>("");
    const forceUpdate = useForceUpdate()

    const onSelectAgent = (agentId: ID | null) => {
        props.module.agentId = agentId
        forceUpdate()
    }

    const onKeyDown = (e: KeyboardEvent) => {
        debug && console.log(debug, 'onKeyDown', props.module.canSendMessage, e)

        // If (no Context when creating new chat) stop submitting
        if (!props.module.canSendMessage) {
            props.form.resetSubmit()
            return
        }

        if ((e.keyCode === 13 || e.code === 'Enter') && !e.shiftKey) {
            e.preventDefault()
            e.stopPropagation()
            props.form.onSubmitClick()
            props.scrollRef.current.scrollToBottom(0)
        }
    }

    // const onChange = (message: string, messageRtf: any) => {
    //     console.log("onChange", props.textArea)
    //     setMessage(message)
    //     // props.textArea.current.focus()
    // }



    return (
        <div ref        = {props.sendMessageArea}
             className  = {props.className}
             style = {{
                 position: 'relative',
             }}
        >

            <div className="message-input position-fixed-bottom border-radius-6">
                <Form
                    className   = "border-radius-6"
                    form        = {props.form}
                >
                    <VScroll containerClass  = "max-h-120">

                        <TextareaRTE
                            ref                     = {props.textArea}
                            className               = "not-draggable ai-text-editor"
                            form                    = {props.form}
                            stateSaveInterval       = {10}
                            editorType              = "chat"
                            name                    = "message"
                            nameRTF                 = "messageRTF"
                            placeholder             = "Ask AI to edit or write..."
                            useLocalSettings        = {false}
                            hideControlsAllowed     = {true}
                            showControls            = {false}
                            showFloatingControls    = {false}
                            showSettingsButton      = {false}
                            disableSlashMenu        = {true}
                            focusOnMount            = {true}
                            mentions                = {MentionsManager.getMentions({companyId: gd.companyId})}
                            onKeyDown               = {onKeyDown}
                        />

                    </VScroll>

                    <div className="flex-row-between-center p-10">
                        <div/>
                        <div className="flex-row-left-center">
                            <AiAgentSelector
                                module   = {props.module}
                                onSelect = {onSelectAgent}
                            />
                            <ButtonSubmitAI
                                className   = "m-l-8"
                                form        = {props.form}
                            />
                        </div>
                    </div>

                </Form>
            </div>
        </div>
    );
}
